import React, { FC, HTMLAttributes } from 'react';
import { cn } from '../../helpers';

interface ParagraphProps extends HTMLAttributes<HTMLElement> {
    /**
     * Determine if the text should be bold
     */
    bold?: boolean;

    /**
     * Determine if the text should be truncated
     */
    truncate?: boolean;
}

/**
 * Use the paragraph instead of the p-tag
 * @param param0
 * @returns
 */
export const Paragraph: FC<ParagraphProps> = ({ children, className, bold, truncate, ...props }) => {
    // A bootstrap override adds margin bottom for all p-tags for some reason.
    const classes = cn('mb-0', className, {
        [className]: className,
        bold: bold,
        'text-truncate': truncate,
    });
    return (
        <p className={classes} {...props}>
            {children}
        </p>
    );
};
